function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var globals = {
  isInitialized: false,
  isAppcuesInitialized: false,
  isMunchkinInitialized: false,
  deferredCalls: [],
  PA_ENV: 'PROD',
  env: function env() {
    return window.PA_ENV || this.PA_ENV;
  },
  debug_session: function debug_session() {
    return window.PA_DEBUG_SESSION || false;
  },
  orwellHost: function orwellHost() {
    if ('PROD' == this.env().toUpperCase()) {
      return 'https://orwell.podium.com';
    } else {
      return window.PA_ORWELL_HOST || 'http://localhost:2002';
    }
  },
  magicHost: function magicHost() {
    if ('PROD' == this.env().toUpperCase()) {
      return 'https://magic.podium.com';
    } else {
      return window.PA_MAGIC_HOST || 'http://localhost:3232';
    }
  },
  munchkinId: function munchkinId() {
    if ('PROD' == this.env().toUpperCase()) {
      return '841-BRM-380';
    } else {
      return window.PA_MUNCHKIN_ID || '805-RXS-474';
    }
  }
};

var name="@podiumhq/podium-analytica";var version="2.1.21";

function getInfo() {
  return {
    libraryVersion: version,
    libraryName: name,
    pageReferrer: document.referrer,
    pageTitle: document.title
  };
}

var session = {
  getInfo: getInfo
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function parse(uuid) {
  if (!validate(uuid)) {
    throw TypeError('Invalid UUID');
  }

  var v;
  var arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = [];

  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35 (name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = parse(namespace);
    }

    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return stringify(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';

  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 0xff;
    var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));

  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

v35('v3', 0x30, md5);

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);

    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }

    M[_i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);

    for (var t = 0; t < 16; ++t) {
      W[t] = M[_i2][t];
    }

    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

v35('v5', 0x50, sha1);

var PODIUM_ANALYTICS_COOKIE = 'pa_user';
var PODIUM_ANALYTICS_USER_ID = PODIUM_ANALYTICS_COOKIE + '_id';
var PODIUM_ANALYTICS_USER_UID = PODIUM_ANALYTICS_COOKIE + '_uid';

var MUNCHKIN_NAME = 'munchkin';
var APPCUES_NAME = 'appcues';
var stack = [];

function is_munchkin_loaded() {
  return is_third_party_script_loaded({
    name: MUNCHKIN_NAME,
    obj: window.Munchkin
  });
}

function is_appcues_loaded() {
  return is_third_party_script_loaded({
    name: APPCUES_NAME,
    obj: window.Appcues
  });
}

function is_third_party_script_loaded() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref.name,
      obj = _ref.obj;

  if (obj) {
    return true;
  } else {
    /* eslint-disable-next-line no-console */
    console.warn("[podium-analytica] ".concat(name, " was blocked from being loaded")); // TODO: This needs to post to orwell, but we can not use af.track
    // because it creates a circular dependency

    return false;
  }
}

function append(args) {
  // make sure we don't get any token cookies
  var all_cookies = document.cookie.replace(/(token)=[^;]+/gi, '$1=CENSORED').split(';').map(function (cookie) {
    return cookie.trim();
  }); // only capture the whitelisted cookies

  var white_listed_keys = [PODIUM_ANALYTICS_COOKIE, PODIUM_ANALYTICS_USER_ID, PODIUM_ANALYTICS_USER_UID];
  var local = white_listed_keys.map(function (key) {
    var value = window.localStorage.getItem(key);
    return value ? "".concat(key, "=").concat(value) : '';
  }).join('; ');
  var cookies = all_cookies.reduce(function (acc, cur) {
    var key = cur.split('=')[0] || '';

    if (white_listed_keys.includes(key)) {
      acc.push(cur);
    }

    return acc;
  }, []).join('; ');
  var meta = {
    i: stack.length,
    at: new Date(),
    libraryVersion: version
  };

  var enriched = _objectSpread2(_objectSpread2(_objectSpread2({}, meta), args), {}, {
    cookies: cookies,
    local: local
  });

  stack.push(enriched);
}

var debug = {
  is_munchkin_loaded: is_munchkin_loaded,
  is_appcues_loaded: is_appcues_loaded,
  append: append,
  stack: stack
};

var TEN_YEARS = 60 * 60 * 1000 * 24 * 365 * 10;
var ID_TOKEN_KEY = 'idToken';

function setCookieIfNotSet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref.name,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value;

  if (!getCookie(name)) {
    setCookie({
      name: name,
      value: value
    });
  }
}

function getCookie(name) {
  return document.cookie.split(';').map(function (cookie) {
    return cookie.trim();
  }).filter(function (cookie) {
    return cookie.includes("".concat(name, "="));
  }).map(function (cookie) {
    return cookie.substring("".concat(name, "=").length, cookie.length);
  }).shift() || null;
}

function eraseCookie(name) {
  document.cookie = "".concat(name, "=; Max-Age=-99999999;");
}

function getIdToken() {
  var token = getCookie(ID_TOKEN_KEY);
  if (!token) throw 'no idToken cookie';
  if (isExpired(token)) throw 'idToken is expired';
  return token;
} // private functions


function setCookie() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref2.name,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? '' : _ref2$value;

  var expires = new Date();
  expires.setTime(expires.getTime() + TEN_YEARS);
  document.cookie = "".concat(name, "=").concat(encodeURIComponent(value), ";expires=").concat(expires.toUTCString(), ";domain=").concat(getTopDomain(), ";");

  if (!getCookie(name)) {
    var msg = "could not set \"".concat(name, "\" cookie");
    /* eslint-disable-next-line no-console */

    console.error(msg);
    debug.append({
      func: 'orwell.setCookie',
      msg: msg
    });
  }
}

function getTopDomain() {
  if (window.location.hostname === 'localhost') {
    return window.location.hostname;
  }

  var cookieName = 'temporary';
  var cookie = "".concat(cookieName, "=fake");
  var domainParts = document.location.hostname.split('.');

  for (var i = domainParts.length - 2; i >= 0; i--) {
    var domain = domainParts.slice(i).join('.'); // try and set a temporary cookie for the given domain
    // (except for the last part which is usually going to be "com")

    document.cookie = "".concat(cookie, ";domain=.").concat(domain, ";"); // check if the cookie was actually set for the given domain

    if (document.cookie.indexOf(cookie) > -1) {
      // delete temporary fake cookie
      eraseCookie(cookieName);
      return ".".concat(domain);
    }
  }
}

function isExpired(idToken) {
  var decodedToken = decodeToken(idToken);
  var date = decodedToken.exp ? decodedToken.exp : null; // convert to millis

  return new Date(date * 1000) < Date.now();
}

function decodeToken(idToken) {
  if (idToken) {
    var tokenParts = idToken.split('.');
    return JSON.parse(atob(tokenParts[1]));
  }

  throw 'Could not decode jwt';
}

var cookies = {
  setCookieIfNotSet: setCookieIfNotSet,
  setCookie: setCookie,
  getCookie: getCookie,
  eraseCookie: eraseCookie,
  getIdToken: getIdToken
};

function init$1() {
  var anonymous_id = generateAnonymousUserId();
  cookies.setCookieIfNotSet({
    name: PODIUM_ANALYTICS_COOKIE,
    value: anonymous_id
  }); // set if not set for localstorage

  var value = window.localStorage.getItem(PODIUM_ANALYTICS_COOKIE) || anonymous_id;
  window.localStorage.setItem(PODIUM_ANALYTICS_COOKIE, value);
  debug.append({
    func: 'orwell.init'
  });
}

function track$1(_ref) {
  var eventName = _ref.eventName,
      payload = _ref.payload;
  payload.event = eventName;
  debug.append({
    func: 'orwell.track',
    event: eventName
  });

  if (globals.debug_session()) {
    payload.stacktrace = JSON.stringify(debug.stack);
  }

  var options = {
    method: 'POST',
    headers: [['Content-Type', 'application/json']],
    body: JSON.stringify(payload)
  };
  return fetch("".concat(globals.orwellHost(), "/api/v1/events"), options);
}

function page$1(_ref2) {
  var pageName = _ref2.pageName,
      payload = _ref2.payload;
  payload.page = pageName;
  debug.append({
    func: 'orwell.page',
    page: pageName
  });

  if (payload.page) {
    return track$1({
      eventName: pageName,
      payload: payload
    });
  } else {
    return track$1({
      eventName: 'page-view.no-page-name',
      payload: payload
    });
  }
}

function identify$1(user) {
  var _user$id = user.id,
      id = _user$id === void 0 ? cookies.getCookie(PODIUM_ANALYTICS_COOKIE) : _user$id,
      _user$uid = user.uid,
      uid = _user$uid === void 0 ? cookies.getCookie(PODIUM_ANALYTICS_COOKIE) : _user$uid;
  cookies.setCookie({
    name: PODIUM_ANALYTICS_USER_ID,
    value: id
  });
  cookies.setCookie({
    name: PODIUM_ANALYTICS_USER_UID,
    value: uid
  });
  window.localStorage.setItem(PODIUM_ANALYTICS_USER_ID, id);
  window.localStorage.setItem(PODIUM_ANALYTICS_USER_UID, uid);

  var meta = _objectSpread2({}, user);

  delete meta.id;
  delete meta.uid;

  var payload = _objectSpread2(_objectSpread2({
    meta: meta
  }, getUserCookies()), {}, {
    appName: 'Web App',
    session: session.getInfo(),
    identify: true
  });

  var options = {
    method: 'POST',
    headers: [['Content-Type', 'application/json']],
    body: JSON.stringify(payload)
  };
  debug.append({
    func: 'orwell.identify'
  });

  if (globals.debug_session()) {
    payload.stacktrace = JSON.stringify(debug.stack);
  }

  return fetch("".concat(globals.orwellHost(), "/api/v1/events"), options);
}

function reset$1() {
  cookies.eraseCookie(PODIUM_ANALYTICS_COOKIE);
  cookies.eraseCookie(PODIUM_ANALYTICS_USER_ID);
  cookies.eraseCookie(PODIUM_ANALYTICS_USER_UID); // localstorage

  window.localStorage.removeItem(PODIUM_ANALYTICS_COOKIE);
  window.localStorage.removeItem(PODIUM_ANALYTICS_USER_ID);
  window.localStorage.removeItem(PODIUM_ANALYTICS_USER_UID);
  debug.append({
    func: 'orwell.reset'
  });
  init$1();
}

function getUserCookies() {
  // validate that cookie and localStorage is the same.
  // If they are not, then add the values to debug stacktrace
  var is_invalid = [cookies.getCookie(PODIUM_ANALYTICS_COOKIE) === window.localStorage.getItem(PODIUM_ANALYTICS_COOKIE), cookies.getCookie(PODIUM_ANALYTICS_USER_ID) === window.localStorage.getItem(PODIUM_ANALYTICS_USER_ID), cookies.getCookie(PODIUM_ANALYTICS_USER_UID) === window.localStorage.getItem(PODIUM_ANALYTICS_USER_UID)].includes(false);

  if (is_invalid) {
    var _values;

    var values = (_values = {}, _defineProperty(_values, PODIUM_ANALYTICS_COOKIE, cookies.getCookie(PODIUM_ANALYTICS_COOKIE)), _defineProperty(_values, "LS_".concat(PODIUM_ANALYTICS_COOKIE), window.localStorage.getItem(PODIUM_ANALYTICS_COOKIE)), _defineProperty(_values, PODIUM_ANALYTICS_USER_ID, cookies.getCookie(PODIUM_ANALYTICS_USER_ID)), _defineProperty(_values, "LS_".concat(PODIUM_ANALYTICS_USER_ID), window.localStorage.getItem(PODIUM_ANALYTICS_USER_ID)), _defineProperty(_values, PODIUM_ANALYTICS_USER_UID, cookies.getCookie(PODIUM_ANALYTICS_USER_UID)), _defineProperty(_values, "LS_".concat(PODIUM_ANALYTICS_USER_UID), window.localStorage.getItem(PODIUM_ANALYTICS_USER_UID)), _defineProperty(_values, "ALL_COOKIES", document.cookie.replace(/(token)=[^;]+/gi, '$1=CENSORED').split(';').map(function (cookie) {
      return cookie.trim();
    })), _values);
    debug.append({
      func: 'orwell.getUserCookies',
      values: values
    });
  }

  return {
    anonymous_user: cookies.getCookie(PODIUM_ANALYTICS_COOKIE) || window.localStorage.getItem(PODIUM_ANALYTICS_COOKIE),
    user_id: cookies.getCookie(PODIUM_ANALYTICS_USER_ID) || window.localStorage.getItem(PODIUM_ANALYTICS_USER_ID),
    user_uid: cookies.getCookie(PODIUM_ANALYTICS_USER_UID) || window.localStorage.getItem(PODIUM_ANALYTICS_USER_UID)
  };
} // Private functions


function generateAnonymousUserId() {
  return v4();
}

var af = {
  init: init$1,
  track: track$1,
  identify: identify$1,
  reset: reset$1,
  getUserCookies: getUserCookies,
  page: page$1
};

function page(pageName, locationUid, meta) {
  // eslint-disable-next-line no-console
  console.debug('[podium-analytica] Called analytics.page()', pageName, locationUid, meta);

  if (!globals.isInitialized) {
    globals.deferredCalls.push({
      method: 'page',
      args: arguments
    }); // eslint-disable-next-line no-console

    console.debug('[podium-analytica] third party scripts are not done loading. Enqueuing analytics.page call');
    return;
  }

  meta = _objectSpread2(_objectSpread2({}, meta), {}, {
    afSyncUID: v4()
  });

  var payload = _objectSpread2({
    appName: 'Web App',
    currentLocationUid: locationUid
  }, meta);

  af.page({
    pageName: pageName,
    payload: _objectSpread2(_objectSpread2(_objectSpread2({}, payload), af.getUserCookies()), {}, {
      session: session.getInfo(),
      meta: meta
    })
  });

  if (debug.is_appcues_loaded()) {
    window.Appcues.page();
  }

  if (debug.is_munchkin_loaded()) {
    window.Munchkin.munchkinFunction('visitWebPage', {
      url: pageName,
      params: "s=".concat(JSON.stringify(payload))
    });
  }
}

function track(event) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // eslint-disable-next-line no-console
  console.debug('[podium-analytica] Called analytics.track()', event, meta);

  if (!event) {
    // eslint-disable-next-line no-console
    console.warn('[podium-analytica] 👆Undefined track event. Check to make sure that your event is defined in podium-analytica and called properly in your app');
    return;
  }

  if (!globals.isInitialized) {
    globals.deferredCalls.push({
      method: 'track',
      args: arguments
    }); // eslint-disable-next-line no-console

    console.debug('[podium-analytica] third party scripts are not done loading. Enqueuing analytics.track call');
    return;
  }

  meta = _objectSpread2(_objectSpread2({}, meta), {}, {
    afSyncUID: v4()
  });

  var payload = _objectSpread2(_objectSpread2({}, meta), {}, {
    appName: 'Web App'
  }, event);

  var eventName = "".concat(event.context, ".").concat(event.feature);
  af.track({
    eventName: eventName,
    payload: _objectSpread2(_objectSpread2({}, af.getUserCookies()), {}, {
      meta: meta,
      appName: 'Web App',
      session: session.getInfo()
    }, event)
  }).catch(function (error) {
    /* eslint-disable-next-line no-console */
    console.error('could not call animal-farm.track', error);
  });

  if (debug.is_appcues_loaded()) {
    window.Appcues.track("".concat(eventName, ".").concat(event.action), payload);
  }

  if (debug.is_munchkin_loaded()) {
    window.Munchkin.munchkinFunction('visitWebPage', {
      url: " - ".concat(eventName, ".").concat(event.action),
      params: "s=".concat(JSON.stringify(payload))
    });
  }
}
function UNSAFE_track(data, eventName) {
  // eslint-disable-next-line no-console
  console.debug('[podium-analytica] Called analytics.UNSAFE_track()', data, eventName);

  if (!globals.isInitialized) {
    globals.deferredCalls.push({
      method: 'UNSAFE_track',
      args: arguments
    }); // eslint-disable-next-line no-console

    console.debug('[podium-analytica] third party scripts are not done loading. Enqueuing analytics.UNSAFE_track call');
    return;
  }

  data = _objectSpread2(_objectSpread2({}, data), {}, {
    afSyncUID: v4()
  });

  var payload = _objectSpread2({
    appName: 'Web App'
  }, data);

  af.track({
    eventName: eventName,
    payload: _objectSpread2(_objectSpread2({
      deprecated: true
    }, af.getUserCookies()), {}, {
      meta: data,
      appName: 'Web App',
      session: session.getInfo()
    })
  }).catch(function (error) {
    /* eslint-disable-next-line no-console */
    console.error('could not call animal-farm.track (from UNSAFE_track)', error);
  });

  if (debug.is_appcues_loaded()) {
    window.Appcues.track(eventName, payload);
  }
}

function show(id) {
  // eslint-disable-next-line no-console
  console.debug('[podium-analytica] Called analytics.show()', id);

  if (!globals.isInitialized) {
    globals.deferredCalls.push({
      method: 'show',
      args: arguments
    }); // eslint-disable-next-line no-console

    console.debug('[podium-analytica] third party scripts are not done loading. Enqueuing analytics.show call');
    return;
  }

  if (debug.is_appcues_loaded()) {
    window.Appcues.show(id);
  }
}

var _excluded = ["id"];
function identify(_x) {
  return _identify.apply(this, arguments);
}

function _identify() {
  _identify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(user) {
    var id,
        other,
        data,
        msg,
        _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // eslint-disable-next-line no-console
            console.debug('[podium-analytica] Called analytics.identify()', user);

            if (globals.isInitialized) {
              _context.next = 5;
              break;
            }

            globals.deferredCalls.push({
              method: 'identify',
              args: _args
            }); // eslint-disable-next-line no-console

            console.debug('[podium-analytica] third party scripts are not done loading. Enqueuing analytics.identify call');
            return _context.abrupt("return");

          case 5:
            af.identify(user);
            id = user.id, other = _objectWithoutProperties(user, _excluded);

            if (debug.is_appcues_loaded()) {
              window.Appcues.identify(id, other); // direct to appcues
            }

            _context.prev = 8;
            _context.next = 11;
            return fetchMunchkinKey(user);

          case 11:
            data = _context.sent;

            if (debug.is_munchkin_loaded()) {
              window.Munchkin.munchkinFunction('associateLead', {
                Email: user.email
              }, data.munchkinKey);
            }

            _context.next = 20;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](8);
            msg = '[podium-analytica] Error fetching Munchkin key from Magic'; // eslint-disable-next-line no-console

            console.warn(msg, _context.t0);
            debug.append({
              func: 'orwell.identify',
              error: "".concat(msg, ". Error: ").concat(_context.t0)
            });

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 15]]);
  }));
  return _identify.apply(this, arguments);
}

function fetchMunchkinKey(_x2) {
  return _fetchMunchkinKey.apply(this, arguments);
}

function _fetchMunchkinKey() {
  _fetchMunchkinKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(user) {
    var query, variables, idToken, response, _yield$response$json, data;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // ask magic what the munchkinKey is
            query = "\n    query munchkinKey($email: String!) {\n      munchkinKey(email: $email)\n    }\n  ";
            variables = {
              email: user.email
            };
            idToken = cookies.getIdToken();
            _context2.next = 5;
            return fetch("".concat(globals.magicHost(), "/graphql"), {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer ".concat(idToken)
              },
              body: JSON.stringify({
                query: query,
                variables: variables
              })
            });

          case 5:
            response = _context2.sent;
            _context2.next = 8;
            return response.json();

          case 8:
            _yield$response$json = _context2.sent;
            data = _yield$response$json.data;
            return _context2.abrupt("return", data);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchMunchkinKey.apply(this, arguments);
}

var publicApiMap = {
  identify: identify,
  page: page,
  UNSAFE_track: UNSAFE_track,
  track: track,
  show: show
};
function init() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$PA_ENV = _ref.PA_ENV,
      PA_ENV = _ref$PA_ENV === void 0 ? 'PROD' : _ref$PA_ENV;

  globals.PA_ENV = PA_ENV; // eslint-disable-next-line no-console

  console.debug("[podium-analytica] PA_ENV=".concat(globals.env(), ".\n      Remove 'Verbose' from your console log levels to hide debug logs."));
  af.init();
  loadAppcues();
  loadMunchkin();
}

var loadAppcues = function loadAppcues() {
  loadScript('//fast.appcues.com/26740.js', initAppcues);
};

var initAppcues = function initAppcues() {
  if (globals.isAppcuesInitialized === false) {
    globals.isAppcuesInitialized = true;
    flushCalls();
  }
};

function loadMunchkin() {
  loadScript('//munchkin.marketo.net/munchkin.js', initMunchkin.bind(null));
}

function initMunchkin() {
  if (globals.isMunchkinInitialized === false) {
    globals.isMunchkinInitialized = true;

    if (debug.is_munchkin_loaded()) {
      window.Munchkin.init(globals.munchkinId(), {
        apiOnly: true
      });
    }

    flushCalls();
  }
}

function flushCalls() {
  if (globals.isMunchkinInitialized && globals.isAppcuesInitialized) {
    globals.isInitialized = true; // eslint-disable-next-line no-console

    console.debug("[podium-analytica] All third party scripts are done loading. Executing queued calls. ".concat(globals.deferredCalls.length, " calls in queue")); // Make sure that all 'identify' calls are on the list

    var queue = globals.deferredCalls.reduce(function (acc, cur) {
      cur.method === 'identify' ? acc.unshift(cur) : acc.push(cur);
      return acc;
    }, []);
    /* eslint-disable-next-line no-console */

    console.log('[podium-analytica] Flushing queued calls.');
    queue.map(function (call, i) {
      /* eslint-disable-next-line no-console */
      console.log("[podium-analytica][".concat(i, "]: ").concat(call.method));
    });

    while (queue.length) {
      var call = queue.shift();
      var args = call.args;

      if (publicApiMap[call.method]) {
        publicApiMap[call.method].apply(publicApiMap, _toConsumableArray(args));
      } else {
        // eslint-disable-next-line no-console
        console.warn('[podium-analytica] Unsupported analytic call', call);
      }
    } // eslint-disable-next-line no-console


    console.debug("[podium-analytica] Queued calls have been executed. ".concat(queue.length, " calls in queue"));
  }
}

function loadScript(srcUrl, onFinish) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = srcUrl;

  script.onreadystatechange = function () {
    if (this.readyState == 'complete' || this.readyState == 'loaded') {
      onFinish();
    }
  };

  script.onload = onFinish;
  script.onerror = onFinish;
  document.getElementsByTagName('head')[0].appendChild(script);
}

var MUNCHKIN_COOKIE_NAME = '_mkto_trk';
function reset() {
  if (!globals.isInitialized) {
    return;
  }

  if (debug.is_appcues_loaded()) {
    window.Appcues.reset();
  }

  af.reset();
  cookies.eraseCookie(MUNCHKIN_COOKIE_NAME);
}

var index = {
  init: init,
  page: page,
  track: track,
  UNSAFE_track: UNSAFE_track,
  identify: identify,
  reset: reset,
  show: show
};

export { index as default };
